import React from 'react';
import PropTypes from 'prop-types';
import { AppDataContext } from '../../context/Context';
import { getNestedValue, isValidJSON } from '../../utils/formatName';
import i18n from '../../i18n';
import MultiSelect from './components/MultiSelect';

export default class DialogContextMultiSelect extends React.Component {
    key = 'id';

    constructor(props) {
        super(props);
        this.key = props.field.key || 'id';
    }

    static contextType = AppDataContext;

    itemClick(category) {
        const value = this.props.value || [];
        const id = category[this.key];
        const selected = value.includes(id);
        const newValue = selected
            ? value.filter((catId) => catId !== id)
            : [...value, id];
        this.props.onChange(this.props.field.id, newValue);
    }

    isCategoryChecked(id) {
        const value = this.props.value || [];
        return value.includes(id);
    }

    getValue = (category, field) => {
        const isNested = field.includes('.');
        const value = isNested
            ? getNestedValue(category, field)
            : category[field];
        const isJSON = isValidJSON(value);
        const parsedValue = isJSON ? JSON.parse(value) : {};
        const validNames = Object.values(parsedValue).filter((name) =>
            name?.trim()
        );
        return validNames.join(' / ') || value;
    };

    getDisplayValue(category) {
        const { primary, secondary } = this.props.field;
        const primaryValue = primary
            ? this.getValue(category, primary)
            : category.name;
        const secondaryValue = secondary
            ? this.getValue(category, secondary)
            : null;
        if (primaryValue && secondaryValue) {
            return `${primaryValue}: ${secondaryValue}`;
        }
        return primaryValue || secondaryValue || 'Unnamed';
    }

    render() {
        const { field, value, onChange } = this.props;
        const categories = this.context.getState().controllersData[field.from];

        if (!categories) {
            console.log('DialogContextMultiSelect: no categories data');
            return null;
        }

        const items = categories.map((c) => ({
            id: c[field.key || 'id'],
            label: this.getDisplayValue(c)
        }));

        return (
            <MultiSelect
                id={field.id}
                label={i18n.t(`columns.${field.label}`)}
                placeholder={i18n.t(`placeholder.${field.label}`)}
                items={items}
                value={value}
                onChange={(newVal) => onChange(field.id, newVal)}
            />
        );
    }
}

DialogContextMultiSelect.propTypes = {
    field: PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        from: PropTypes.string.isRequired,
        primary: PropTypes.string,
        secondary: PropTypes.string,
        required: PropTypes.bool
    }).isRequired,
    value: PropTypes.arrayOf(PropTypes.number),
    onChange: PropTypes.func.isRequired
};

DialogContextMultiSelect.defaultProps = {
    value: []
};
